<section
  class="fixed bottom-0 z-50 w-full p-1 bg-white dark:bg-blacker border-borders-light dark:border-borders-darker border-t"
>
  <ul class="flex justify-between items-start text-center text-xs">
    <li
      class="leading-[14px]"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{exact: true}"
    >
      <a routerLink="/">
        <span
          class="inline-block w-[26px] h-[26px] mask-[url(/assets/images/icons/home.svg)] mask-size-[26px_26px] bg-black dark:bg-white"
        ></span
        ><br />
        {{ "HOME" | translate }}
      </a>
    </li>
    <li class="leading-[14px]" [ngClass]="{active: isWorkRoute}">
      <button
        (click)="openModal('myWorks')"
        (keyup)="onKeyUp($event, 'myWorks')"
        tabindex="0"
      >
        <span
          class="inline-block w-[26px] h-[26px] mask-[url(/assets/images/icons/works.svg)] mask-size-[26px_26px] bg-black dark:bg-white"
        ></span
        ><br />
        {{ "EXPLORER" | translate }}
      </button>
    </li>
    <li class="leading-[14px]">
      <button
        routerLink="/compass"
        tabindex="0"
        aria-label="{{ 'FIND_A_GEM' | translate }}"
        class="m-auto -mt-3 w-7 h-7"
      >
        <span class="gem-shine relative block m-auto w-[54px] h-[54px]">
          @if(isDarkMode) {
          <img
            src="/assets/images/icons/gem-dark.svg"
            alt=""
            class="relative block w-full h-full"
          />
          } @else {
          <img
            src="/assets/images/icons/gem.svg"
            alt=""
            class="relative block w-full h-full"
          />
          }
        </span>
        {{ "SNIFF" | translate }}
      </button>
    </li>

    <li class="leading-[14px]" [ngClass]="{active: isListsRoute}">
      <a routerLink="/collections" tabindex="0">
        <span
          class="inline-block w-[26px] h-[26px] mask-[url(/assets/images/icons/lists.svg)] mask-size-[26px_26px] bg-black dark:bg-white"
        ></span
        ><br />
        {{ "COLLECTIONS" | translate }}
      </a>
    </li>
    <li class="leading-[14px]">
      <a
        (click)="openModal('addWork')"
        (keyup)="onKeyUp($event, 'addWork')"
        tabindex="0"
      >
        <span
          class="inline-block w-[26px] h-[26px] mask-[url(/assets/images/icons/search.svg)] mask-size-[26px_26px] bg-black dark:bg-white"
        ></span
        ><br />
        {{ "SEARCH" | translate }}
      </a>
    </li>
    <!-- <li
      class="leading-[14px]"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{exact: true}"
    >
      <a routerLink="/stats">
        <span
          class="inline-block w-[28px] h-[28px] mask-[url(/assets/images/icons/stats.svg)] mask-size-[28px_28px] bg-black dark:bg-white"
        ></span
        ><br />
        {{ "STATS" | translate }}
      </a>
    </li> -->
  </ul>
</section>

<app-modal
  modalId="myWorks"
  #myWorksModal
  classes="!h-[355px] lg:!h-[329px] !top-auto bottom-0 rounded-t-lg"
  [shouldSwipeDownToClose]="true"
>
  <app-my-works-nav [user]="user"></app-my-works-nav>
</app-modal>
